export function metricLabel(metric: string, labels: Record<string, string> = {}): string {
  if (labels[metric] && !labels[metric].includes(metric)) return labels[metric];
  const name = metric.split('.').pop()!.replace(/_/g, ' ');
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function displayDiagnosis<T extends Record<string, any>>(envelope: T): T {
  const labels: Record<string, string> = {};
  if (envelope.target?.label) labels[envelope.target.metric] = envelope.target.label;
  for (const node of envelope.chain || []) if (node.label) labels[node.metric] = node.label;
  for (const driver of envelope.drivers || []) if (driver.kind === 'metric' && driver.label) labels[driver.id] = driver.label;
  const metrics = [envelope.target?.metric, ...(envelope.chain || []).map((node: any) => node.metric),
    ...(envelope.best_path || []), ...(envelope.drivers || []).filter((d: any) => d.kind === 'metric').map((d: any) => d.id)];
  for (const metric of metrics) if (typeof metric === 'string') labels[metric] = metricLabel(metric, labels);
  const keys = new Set(['headline', 'summary', 'reason', 'label', 'caveat', 'residual_note', 'text', 'detail']);
  const names = Object.keys(labels).filter(name => name.includes('.')).sort((a, b) => b.length - a.length);
  const pattern = names.length ? new RegExp(`(^|[^A-Za-z0-9_.])(${names.map(name => name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})(?![A-Za-z0-9_]|\\.[A-Za-z0-9_])`, 'g') : null;
  const shown = JSON.parse(JSON.stringify(envelope, (key, value) => {
    if (!keys.has(key) || typeof value !== 'string') return value;
    return pattern ? value.replace(pattern, (_match: string, prefix: string, metric: string) => prefix + labels[metric]) : value;
  }));
  if (shown.target?.metric) shown.target.label = metricLabel(shown.target.metric, labels);
  for (const driver of shown.drivers || []) {
    if (driver.kind === 'metric') driver.label = driver.label || metricLabel(driver.id, labels);
  }
  return shown;
}
